import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { fetchIndustries } from "../lib/api";

export default function IndustriesPage() {
  const [industries, setIndustries] = useState([]);
  useEffect(() => { fetchIndustries().then(setIndustries).catch(() => {}); }, []);

  return (
    <div className="min-h-screen bg-white" data-testid="industries-page">
      <div className="bg-nibro-sage-pale py-12">
        <div className="mx-auto max-w-[1400px] px-5 lg:px-10">
          <div className="nibro-frame">
            <h1 className="nibro-section-title">INDUSTRIEËN</h1>
            <p className="mt-3 text-center text-sm text-zinc-600">
              Oplossingen op maat per industrie — food, chemie, offshore, datacenter & meer
            </p>
          </div>
        </div>
      </div>

      <div className="mx-auto max-w-[1400px] px-5 py-12 lg:px-10">
        <div className="grid grid-cols-1 gap-5 sm:grid-cols-2 lg:grid-cols-3">
          {industries.map((i) => (
            <Link
              key={i.slug}
              to={`/industries/${i.slug}`}
              className="nibro-card group"
              data-testid={`industry-link-${i.slug}`}
            >
              <div className="relative aspect-[4/3] overflow-hidden">
                <img
                  src={i.image}
                  alt={i.name}
                  className="h-full w-full object-cover transition duration-700 group-hover:scale-105"
                  loading="lazy"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/70 via-black/20 to-transparent" />
                <div className="absolute bottom-0 left-0 right-0 p-4">
                  <h3 className="font-display text-xl font-bold uppercase tracking-wide text-white">
                    {i.name_nl || i.name}
                  </h3>
                </div>
              </div>
              <div className="p-5">
                <p className="text-sm text-zinc-600 line-clamp-2">{i.description}</p>
                <div className="mt-3 flex flex-wrap gap-1.5">
                  {(i.highlights || []).slice(0, 3).map((h) => (
                    <span key={h} className="rounded border border-nibro-sage/40 bg-nibro-sage-pale px-2 py-0.5 font-mono text-[10px] uppercase tracking-wider text-nibro-sage-dark">
                      {h}
                    </span>
                  ))}
                </div>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </div>
  );
}
